import React from 'react';
import { Alert, Space, Button } from 'antd';
import { CheckCircleOutlined, EyeOutlined } from '@ant-design/icons';

const SuccessAlert = ({ validDataCount, onPreview, uploading }) => {
	return (
		<div className="success-validation-wrapper">
			<Alert
				message={
					<Space direction="vertical" size={8} style={{ width: '100%' }}>
						<Space>
							<CheckCircleOutlined style={{ color: '#52c41a', fontSize: 20 }} />
							<span style={{ fontSize: 18, fontWeight: 600, color: '#389e0d' }}>
								Validation Successful!
							</span>
						</Space>
						<div style={{ paddingLeft: 28 }}>
							<p style={{ margin: 0, fontSize: 14, color: '#595959' }}>
								All records passed validation checks. <strong style={{ color: '#52c41a' }}>{validDataCount}</strong> customer{validDataCount > 1 ? 's' : ''} ready to be uploaded to the system.
							</p>
						</div>
					</Space>
				}
				type="success"
				showIcon={false}
				action={
					<Button 
						type="primary" 
						size="large" 
						onClick={onPreview} 
						loading={uploading}
						icon={<EyeOutlined />}
						style={{ 
							minWidth: 200,
							height: 44,
							fontSize: 16,
							fontWeight: 600,
							boxShadow: '0 4px 12px rgba(24, 144, 255, 0.3)'
						}}
					>
						Preview & Submit
					</Button>
				}
				style={{
					border: '2px solid #b7eb8f',
					borderRadius: 12,
					background: 'linear-gradient(135deg, #f6ffed 0%, #d9f7be 100%)',
					boxShadow: '0 4px 12px rgba(82, 196, 26, 0.15)'
				}}
			/>
		</div>
	);
};

export default SuccessAlert;
